var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlarmMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17L5.1241 16.7164C5.62107 15.5804 5.92107 14.3682 6.01124 13.1315L6.3682 8.2361C6.58341 5.28465 9.04071 3 12 3V3C14.9593 3 17.4166 5.28465 17.6318 8.2361L17.9888 13.1315C18.0789 14.3682 18.3789 15.5804 18.8759 16.7164L19 17",
    stroke: "#ABABAB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14L5 17H19L18 14L17 6L15 4L12 3L9 4L7 6L6 14Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17L19 17",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19",
    stroke: "#ABABAB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmMedium);
export default __webpack_public_path__ + "static/media/ic_alarm_medium.45bf354050f628a1bbf03fbc6fdda106.svg";
export { ForwardRef as ReactComponent };